import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=4bd9198a&"
import script from "./StatusIndicator.vue?vue&type=script&lang=ts&"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports